export const CLEAR_GEO_LOCATION = 'CLEAR_GEO_LOCATION';
export const PERMANENTLY_DISMISS_STICKY = 'PERMANENTLY_DISMISS_STICKY';
export const UPDATE_ANY_LEAD_POPUP_SHOWN = 'UPDATE_ANY_LEAD_POPUP_SHOWN';
export const UPDATE_CALL_SERVICE = 'UPDATE_CALL_SERVICE';
export const UPDATE_COUNTY = 'UPDATE_COUNTY';
export const UPDATE_FILTER = 'UPDATE_FILTER';
export const UPDATE_GEO_LOCATION = 'UPDATE_GEO_LOCATION';
export const UPDATE_LEAD = 'UPDATE_LEAD';
export const UPDATE_NTM_ACTIVE_STEP = 'UPDATE_NTM_ACTIVE_STEP';
export const UPDATE_NTM_VISITED = 'UPDATE_NTM_VISITED';
export const UPDATE_PRE_OEP_STATE_CONFIG = 'UPDATE_PRE_OEP_STATE_CONFIG';
export const UPDATE_OEP_STATE_CONFIG = 'UPDATE_OEP_STATE_CONFIG';
export const UPDATE_PHONE = 'UPDATE_PHONE';
export const UPDATE_PLAN_TYPE = 'UPDATE_PLAN_TYPE';
export const UPDATE_TRACKING_PARAMS = 'UPDATE_TRACKING_PARAMS';
export const UPDATE_TRACKING_STATUS = 'UPDATE_TRACKING_STATUS';
export const UPDATE_ZIP_AND_COUNTY = 'UPDATE_ZIP_AND_COUNTY';
export const UPDATE_ZIP_MODAL_DESTINATION = 'UPDATE_ZIP_MODAL_DESTINATION';
export const UPDATE_ZIP_MODAL_HEADING = 'UPDATE_ZIP_MODAL_HEADING';
export const UPDATE_ZIP_MODAL_CTA = 'UPDATE_ZIP_MODAL_CTA';
export const UPDATE_MULTI_COUNTY_LIST = 'UPDATE_MULTI_COUNTY_LIST';
export const UPDATE_OEP_STATE_PERIOD = 'UPDATE_OEP_STATE_PERIOD';

export const updateAnyLeadPopupShown = () => {
    return {
        type: UPDATE_ANY_LEAD_POPUP_SHOWN,
    };
};

export const updateCallService = (data: {
    allianceId: string;
    companyUrl: string;
    hours: string;
    lightModeHeader: string;
    logo: string;
    partnerName: string;
    partnershipType: string;
    segmentType: string;
    suppressEmailCapturePopup: string;
    tcpaDisclaimer: string;
    throttle: string;
}) => {
    return {
        type: UPDATE_CALL_SERVICE,
        payload: data,
    };
};

export const updateFilter = (filter: string) => {
    return {
        type: UPDATE_FILTER,
        payload: filter,
    };
};

export const updateLead = (leadId: string, leadToken: string) => {
    return {
        type: UPDATE_LEAD,
        payload: { leadId, leadToken },
    };
};

export const updateNtmActiveStep = (step: string) => {
    return {
        type: UPDATE_NTM_ACTIVE_STEP,
        payload: step,
    };
};

export const updateNtmVisited = (page: string) => {
    return {
        type: UPDATE_NTM_VISITED,
        payload: page,
    };
};

export const updateTrackingStatus = (data: string) => {
    return {
        type: UPDATE_TRACKING_STATUS,
        payload: data,
    };
};

export const updatePreOEPStateConfig = (data: LeadFormData) => {
    return {
        type: UPDATE_PRE_OEP_STATE_CONFIG,
        payload: data,
    };
};

export const updateOEPStateConfig = (data: BannerData[]) => {
    return {
        type: UPDATE_OEP_STATE_CONFIG,
        payload: data,
    };
};

export const updatePhone = (data: { number: string; isFinal: boolean }) => {
    return {
        type: UPDATE_PHONE,
        payload: data,
    };
};

export const updatePlanType = (planType: string) => {
    return {
        type: UPDATE_PLAN_TYPE,
        payload: planType,
    };
};

export const updateTrackingParams = (data: Record<string, string>) => {
    return {
        type: UPDATE_TRACKING_PARAMS,
        payload: data,
    };
};

export const updateCounty = (countyName: string) => {
    return {
        type: UPDATE_COUNTY,
        payload: countyName,
    };
};

export const updateZipAndCounty = (zip: string, countyName: string) => {
    return {
        type: UPDATE_ZIP_AND_COUNTY,
        payload: { zip, countyName },
    };
};

export const updateGeoLocation = (payload: GeoLocation) => {
    return {
        type: UPDATE_GEO_LOCATION,
        payload,
    };
};

export const updateMultiCountyList = (payload: GeoLocation[]) => {
    return {
        type: UPDATE_MULTI_COUNTY_LIST,
        payload,
    };
};

export const clearGeoLocation = () => {
    return {
        type: CLEAR_GEO_LOCATION,
    };
};

export const permanentlyDismissStickyCta = () => {
    return {
        type: PERMANENTLY_DISMISS_STICKY,
    };
};

export const updateZipModalCta = (cta: string) => {
    return {
        type: UPDATE_ZIP_MODAL_CTA,
        payload: cta,
    };
};

export const updateZipModalDestination = (destination: string) => {
    return {
        type: UPDATE_ZIP_MODAL_DESTINATION,
        payload: destination,
    };
};

export const updateZipModalHeading = (heading?: string) => {
    return {
        type: UPDATE_ZIP_MODAL_HEADING,
        payload: heading,
    };
};

export const updateOEPStatePeriod = (data: PeriodData) => {
    return {
        type: UPDATE_OEP_STATE_PERIOD,
        payload: data,
    };
};
